import React, { useContext, useState } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import ObjectDescription from 'src/sites/kits/Object/elements/Description'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'

// TODO: This should be consolidate with Object/elements/Description
// PR #967
const ObjectDescriptionBlock = ({ truncateText }) => {
   const [showTruncatedText, setShowTruncatedText] = useState(false)
   const { theme } = useGlobalState()

   const { initiative } = useContext(InitiativeHierarchyContext)
   const initiativeBody = initiative?.body?.elements?.[0]?.body || ''
   const shouldTruncateBody = truncateText && initiativeBody.length > 240

   if (!initiativeBody) {
      return null
   }

   return (
      <>
         <View
            position="relative"
            width="100%"
            paddingRight="10px"
            marginBottom={!shouldTruncateBody && '25px'}
            maxHeight={shouldTruncateBody && !showTruncatedText &&
               '90px[a-b] 125px[c] 90px[d] 125px[e-f]'
            }
            style={{ overflow: 'hidden' }}>
            <ObjectDescription description={initiativeBody} textSize="lg" />
         </View>
         {shouldTruncateBody && (
            <View
               onClick={() => setShowTruncatedText(prevState => !prevState)}
               width="100%"
               padding="10px 0px"
               marginBottom="25px"
               style={{ cursor: 'pointer' }}>
               <Text
                  weight="medium"
                  size={theme.tmpSubBodyTextSize}
                  color={theme.tmpButtonTextColor}>
                  {showTruncatedText ? 'Show less' : 'Show more'}
               </Text>
            </View>
         )}
      </>
   )
}

ObjectDescriptionBlock.propTypes = {
   truncateText: PropTypes.bool
}

ObjectDescriptionBlock.defaultProps = {
   truncateText: false
}

export default ObjectDescriptionBlock
